import abnormalData from '@/router/modules/abnormalData'
import cardStaticsMap from '@/router/modules/cardStaticsMap'
import consumptionData from '@/router/modules/consumptionData'
import oneCarmulticard from '@/router/modules/oneCarmulticard'
import conCard from '@/router/modules/conCard'
import freight from '@/router/modules/freight'
import log from '@/router/modules/log'
import keyAccountManage from '@/router/modules/keyAccountManage'
import roadOperation from '@/router/modules/roadOperation'
import operationData from '@/router/modules/operationData'

const asyncRouterMap = [
    ...abnormalData,//异常数据
    ...cardStaticsMap,//办卡量统计
    ...oneCarmulticard,//一车多卡
    ...consumptionData,//消费数据监控
    ...conCard,//消费卡数据统计
    ...freight,//货运平台数据
    ...roadOperation,//全国道路运营热力图
    ...operationData,//运营数据
    ...log,//日志
    ...keyAccountManage,//重点客户列表
    {path: '*', redirect: '/404', hidden: true}
]
console.log(asyncRouterMap)
export default asyncRouterMap;
